<template>
  <div class="home page">
    <filters/>
    <main>
      <selector
        :landscapemode="landscapemode"
        :imagetype="imageRatio"
        :mapwidth="mapWidth"
        :mapheight="mapHeight"
      ></selector>
    </main>
  </div>
</template>

<script>
    import Filters from '../components/Filters.vue'
    import Selector from '../components/Selector.vue'

    export default {
      name: 'home',  components: {
            Filters,
            Selector
        },


        data() {
          return {
              mapWidth: null,
              mapHeight: null,
              imageRatio: '',
              landscapemode: null
          }
        },

        created() {
            this.mapWidth = parseInt(this.$getGlobalData.maps[0].width)
            this.mapHeight = parseInt(this.$getGlobalData.maps[0].height)
        },

        mounted(){
            if(this.$store.state.apiData.group_mode){
              this.$router.replace({name: 'stackingplan'})
              return
            }
            this.setImageRatio();
        },

        methods: {
            setImageRatio (){
                if(this.mapWidth < this.mapHeight){
                    this.imageRatio = 'portrait'
                    this.landscapemode = false

                }else {
                    this.imageRatio = 'landscape'
                    this.landscapemode = true
                }
            }
        }
    }
</script>
